import axios from 'axios';
import { configureApi } from '../config/configureApi';
import * as storageService from '../utils/storage';

export class ClientService {
  // token: string;
  axios;

  constructor(api) {
    this.axios = api;
    this.axios.interceptors.request.use(this.onPreRequest, this.onRequestFailure);
    this.axios.interceptors.response.use(this.onRequestSuccess, this.onRequestFailure);
  }

  async onPreRequest(config) {
    const user_current = storageService.getItem('USER_CURRENT');

    if (user_current && user_current.access_token) {
      config.headers.Authorization = `Bearer ${user_current.access_token}`;
    }

    return config;
  }

  onRequestSuccess(response) {
    return response;
  }

  onRequestFailure(error) {
    const response = error.response;

    if ([401, 403].includes(response.status)) {
      storageService.clear()

      if (!response.config.url.includes('/auth/me')) {
        window.location.href = `/#/login`;
      }
    }

    return Promise.reject(response);
  }

  setHeader(key, value) {
    // console.log('key', key);
    // console.log('value', value);
    this.axios.defaults.headers.common[key] = value;
    this.axios.defaults.baseURL = configureApi.baseURL;
  }

  deleteHeader(key) {
    // delete this.api.defaults.headers.common[key];
  }

  toResult(request) {
    return request.then((response) => {
      const { status, data } = response;

      return {
        ok: status === 200,
        ...data,
        success: data && data.hasOwnProperty('success') && data.success === true,
      };
    });
  }

  get(path, options) {
    return this.toResult(this.axios.get(path, options));
  }

  post(path, body, options) {
    return this.toResult(this.axios.post(path, body, options));
  }

  put(path, body, options) {
    return this.toResult(this.axios.put(path, body, options));
  }

  delete(path) {
    return this.toResult(this.axios.delete(path));
  }
}

const client = new ClientService(axios.create({
  baseURL: configureApi.baseURL,
  timeout: configureApi.timeout,
}));
const axiosClient = client.axios

export { client, axiosClient };
